import { culture } from '../utils/intl';

import startClickTracking from './click-tracking';
import startLoadTracking from './load-tracking';
import { pushTrackingData } from './utils';

const cultureInfo = culture.split('-');

const language = cultureInfo[0].toLocaleLowerCase();
const environment = cultureInfo[1].toLocaleLowerCase();
const { dataset: {
	gtmIsInternal: internalTraffic = false,
	gtmLoginStatus: loginStatus = 'logged out',
	gtmPreferredBroker: preferredBroker = 'unavailable',
} = {} } = document.body;

const onPageLoad = () => {
	pushTrackingData({
		event: 'page_default',
		page: {
			language,
			environment,

		},
		user: {
			internalTraffic,
			loginStatus,
			preferredBroker,
		},
	});

	startClickTracking(document.body);
	startLoadTracking(document.body);
};

window.addEventListener('load', onPageLoad);
